<template>
  <Layout>
    <template v-slot:quickmsg>
      <transition name="fade">
        <div v-if="quickmsg != ''">{{ quickmsg }}</div>
      </transition>
    </template>

    <h5>
      Stan magazynowy na żywo. Ostatnie odświeżenie: <b>{{ lastrefr }}</b>
    </h5>

    <div class="mt-4">
      Numer katalogowy:
      <input
        type="text"
        name="s"
        id="s"
        class="right f14"
        v-model="srchboxcandidate"
      />
    </div>

    <div class="mt-2">
      Wyniki:
      <table class="">
        <tr>
          <th>Nr kat</th>
          <th>Nazwa</th>
          <th>Aktualny stan</th>
          <th>Dziś zamówiono</th>
        </tr>
        <tr>
          <td class="nrk">{{ dataobj.nr_kat }}</td>
          <td>{{ dataobj.nazwa }}</td>
          <td :class="classByStock(dataobj.stock)">
            {{ dataobj.stock }}
            <div class="upd">{{ dataobj.datetime }}</div>
          </td>
          <td class="num">{{ dataobj.todaysenovapassed }}</td>
        </tr>
      </table>
    </div>

    <div class="mt-2">
      <b>Informacje:</b>
      <ul>
        <li>
          Aktualny stan: jest to ilość zgodna z tym, co widzi użytkownik ISZ na
          karcie produktu
        </li>
        <li>
          Dziś zamówiono: jest to ilość w zamówieniach z dnia bieżącego
          oznaczonych jako "przekazane do Enovy". Decyduje data zamówienia a nie
          data przekazania.
        </li>
        <li>
          Po prawidłowym wyszukaniu produktu, stan odświeża się co
          {{ milisecsAutoRefrData / 1000 }} sekund. Obserwuj datę odświeżenia,
          aby orientować się co do aktualności danych.
        </li>
      </ul>
    </div>
  </Layout>
</template>
     

<script>
import moment from "moment";
import _ from "lodash";

export default {
  name: "WarehouseLive",
  data() {
    return {
      dataobj: {},
      quickmsg: "",
      lastrefr: "b.d.",
      srchboxcandidate: "",
      srchbox: "",
      milisecsAutoRefrData: 30000,
    };
  },
  created() {
    let vm = this;
    setInterval(() => {
      if (vm.srchbox !== "") {
        this.getdata(vm.srchbox);
        console.log("this.srchbox: ", vm.srchbox);
      }
    }, vm.milisecsAutoRefrData);
  },
  mounted() {},
  computed: {},
  methods: {
    getdata(nv) {
      console.log("nv: ", nv);
      let apiurl =
        this.$config.API_URL + "/swmoneproductbycatnum?catnum=" + this.srchbox;

      console.log(apiurl);

      if (nv !== "") this.debounce_fun(nv, apiurl, this.$axios, this);
      else this.dataobj = {};
    },
    valid(nv) {
      return true;
    },
    classByStock(stock) {
      if (typeof stock === "undefined") return "num";
      if (stock == 0) return "num stockred";
      if (stock <= 10) return "num stockorange";
      return "num stockgreen";
    },
    debounce_fun: _.debounce((nv, apiurl, ax, vm) => {
      var that = this;

      ax({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          if (response.data && response.data.length === 1) {
            vm.dataobj = response.data[0];
          } else {
            vm.data.data = {};
          }
        })
        .catch(function (error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    }, 1000),
  },
  watch: {
    srchboxcandidate(nv) {
      if (this.valid(nv)) {
        this.srchbox = nv;
      }

      this.srchboxcandidate = this.srchbox;
    },
    srchbox(nv) {
      if (nv === "") this.dataobj = {};
      this.getdata(nv);
    },
    dataobj(nv) {
      if (nv.datetime) this.lastrefr = nv.datetime;
      else this.lastrefr = "b.d.";
    },
  },
};
</script>

<style scoped>
table {
  border-spacing: 10px;
  border-collapse: separate;
  width: 100%;
}

b,
th {
  font-weight: 700;
}

td,
th {
  padding: 10px;
  border-radius: 9px;
}

td {
  background-color: #c1c0d3;
  font-size: 18pt;
}

.upd {
  font-size: 8pt;
}

.num {
  text-align: right;
}

.stockred {
  background-color: #fc9292;
}
.stockorange {
  background-color: #ffcc66;
}
.stockgreen {
  background-color: #97ff80;
}

.nrk {
  font-weight: 700;
  white-space: nowrap;
}
</style>